import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/interfaces/UserProfile';

@Component({
    selector: 'app-probation-order-success',
    templateUrl: './probation-order-success.component.html',
    styleUrls: ['./probation-order-success.component.scss'],
    standalone: false
})
export class ProbationOrderSuccessComponent {
  userProfile?: UserProfile;

  constructor(private router: Router) { }

  ngOnInit(): void {
       setTimeout(() => this.scrollToTop(), 500);
      window.onbeforeunload = null;
  }
  
  navigateToRequestRecords() {
      this.router.navigateByUrl('/requestRecords');
  }

  navigateToDashboard() {
      this.router.navigateByUrl('/dashboard');
  }

  scrollToTop() {
      window.scrollTo(0, 0);
  }
}
